import {ENV} from '@/constants/EnvConstants';

export const API_URL_USERS = ENV.VITE_APIS_USERS_DOMAIN_URL;

export const API_URL_BANKING = ENV.VITE_APIS_BANKING_DOMAIN_URL;
export const API_URL_FINTECH = ENV.VITE_APIS_FINTECH_DOMAIN_URL;
export const API_URL_KYC = ENV.VITE_APIS_KYC_DOMAIN_URL;
